var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCarListDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.209 3.00195C16.384 3.01395 17.562 3.11095 18.33 3.87895C19.209 4.75795 19.209 6.17195 19.209 8.99995V15C19.209 17.829 19.209 19.243 18.33 20.122C17.452 21 16.037 21 13.209 21H7.20898C4.38098 21 2.96598 21 2.08798 20.122C1.20898 19.242 1.20898 17.829 1.20898 15V8.99995C1.20898 6.17195 1.20898 4.75795 2.08798 3.87895C2.85598 3.11095 4.03398 3.01395 6.20898 3.00195",
    stroke: "#25282F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70898 13H15.209M5.20898 13H5.70898M5.20898 9.5H5.70898M5.20898 16.5H5.70898M8.70898 9.5H15.209M8.70898 16.5H15.209",
    stroke: "#25282F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20898 2.5C6.20898 2.10218 6.36702 1.72064 6.64832 1.43934C6.92963 1.15804 7.31116 1 7.70898 1H12.709C13.1068 1 13.4883 1.15804 13.7696 1.43934C14.0509 1.72064 14.209 2.10218 14.209 2.5V3.5C14.209 3.89782 14.0509 4.27936 13.7696 4.56066C13.4883 4.84196 13.1068 5 12.709 5H7.70898C7.31116 5 6.92963 4.84196 6.64832 4.56066C6.36702 4.27936 6.20898 3.89782 6.20898 3.5V2.5Z",
    stroke: "#25282F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCarListDefault);
export default __webpack_public_path__ + "static/media/ic_car_list_default.d0f7d3d42808b7868b8a2aec0bbe4d34.svg";
export { ForwardRef as ReactComponent };